/**
 * 🪟 Modals registering file
 * BarrelGun: auto-generated file, do not edit!
 */
import type React from 'react';

import { DebuggerModal } from '../components/Debugger/Debugger.modal';
import { OrderCreateErrorModal } from '../components/Order/OrderCreateError.modal';
import { OrderCreateSuccessModal } from '../components/Order/OrderCreateSuccess.modal';
import { OrderQueueModal } from '../components/Order/OrderQueue.modal';
import { ReservationErrorModal } from '../components/Reservation/ReservationError.modal';
import { ReservationExpiredModal } from '../components/Reservation/ReservationExpired.modal';

/**
 * Registered contextual modal components
 * @export
 */
export const REGISTERED_MODALS = {
	reservationExpired: ReservationExpiredModal,
	reservationError: ReservationErrorModal,
	orderQueue: OrderQueueModal,
	orderCreateSuccess: OrderCreateSuccessModal,
	orderCreateError: OrderCreateErrorModal,
	debugger: DebuggerModal,
};

/**
 * Registered contextual modal name union
 * @export
 */
export type RegisteredModals = typeof REGISTERED_MODALS;

/**
 * Registered modal props type
 * @export
 */
export type RegisteredModalProps<Modal extends keyof RegisteredModals> = React.ComponentProps<RegisteredModals[Modal]>;
